
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("jyRFW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $e3dad41ff661c776$var$_swiper = $e3dad41ff661c776$var$_interopRequireDefault((parcelRequire("2mpqL")));

var $5PBbn = parcelRequire("5PBbn");
function $e3dad41ff661c776$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $e3dad41ff661c776$var$init = module.exports.init = function init() {
    var imageGalleries = document.querySelectorAll(".image-gallery-box");
    imageGalleries.forEach(function(imageGallery) {
        var id = imageGallery.querySelector(".swiper.image-gallery-slider").id;
        var igSlider = new $e3dad41ff661c776$var$_swiper["default"]("#" + id, {
            modules: [
                $5PBbn.Navigation,
                $5PBbn.Keyboard,
                $5PBbn.A11y,
                $5PBbn.EffectFade
            ],
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true
            },
            on: {
                afterInit: function afterInit(swiper) {
                    var slides = swiper.slides;
                    slides.forEach(function(slide, index) {
                        var slidePage = slide.querySelector(".pages");
                        slidePage.innerHTML = "".concat(index + 1, "/").concat(slides.length);
                    });
                    imageGallery.classList.add("slider-init");
                }
            }
        });
    });
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$71511d61b312f219; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3d624443cd99befe$export$71511d61b312f219; });
function $3d624443cd99befe$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$71511d61b312f219; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=imageGallery.module.d71a706e.js.map
